module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASBAMAAAB/WzlGAAAAAXNSR0IB2cksfwAAAC1QTFRFAAAAqqqqqqqqqqqqra2tq6urqqqqqqqqqqqqqqqqrKysqqqqqKioqqqqra2tLBb+JwAAAA90Uk5TAAZOxR9J8v/QHi7gL+Mc+TEGygAAADZJREFUeJxjYBBgAAEmEzAVVjEBRK0ubwFRPNsrHED0aezc6xUPEBREEKoEhQM1DGo01CKItQDyvBgPkXWDjQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icons8-right_4@2x.png
// module id = 2jvw
// module chunks = 1